export default __webpack_public_path__ + "8b063526ec9a5f33e6abd268f6ba78e6.png";